/**
 * Paper originals receipt problem types (IMP-001H-5B) — mirrors backend enum.
 */
export const CLOSING_PACKAGE_ORIGINALS_PROBLEM_TYPE = {
  MISSING_DOCUMENTS: 'MISSING_DOCUMENTS',
  WRONG_DOCUMENTS: 'WRONG_DOCUMENTS',
  DAMAGED_PACKAGE: 'DAMAGED_PACKAGE',
  COURIER_ISSUE: 'COURIER_ISSUE',
  WRONG_RECIPIENT: 'WRONG_RECIPIENT',
  CLIENT_REJECTED: 'CLIENT_REJECTED',
  OTHER: 'OTHER',
} as const;

export type ClosingPackageOriginalsProblemType =
  (typeof CLOSING_PACKAGE_ORIGINALS_PROBLEM_TYPE)[keyof typeof CLOSING_PACKAGE_ORIGINALS_PROBLEM_TYPE];

export type ClosingPackageOriginalsDispatchCycleDto = {
  cycleNumber: number;
  preparedAt: string | null;
  dispatchedAt: string | null;
  estimatedReceiptAt: string | null;
  receivedAt: string | null;
  deliveryMethod: string | null;
  trackingNumber: string | null;
  confirmationResult: 'RECEIVED' | 'PROBLEM';
  problemType: ClosingPackageOriginalsProblemType | null;
  comment: string | null;
  sealedAt: string;
};

export const ORIGINALS_PROBLEM_TYPE_OPTIONS: Array<{
  value: ClosingPackageOriginalsProblemType;
  label: string;
}> = [
  { value: 'MISSING_DOCUMENTS', label: 'Не хватает документов' },
  { value: 'WRONG_DOCUMENTS', label: 'Некорректные документы' },
  { value: 'DAMAGED_PACKAGE', label: 'Документы повреждены' },
  { value: 'COURIER_ISSUE', label: 'Курьер не доставил' },
  { value: 'WRONG_RECIPIENT', label: 'Неверный адрес / получатель' },
  { value: 'CLIENT_REJECTED', label: 'Клиент запросил повторную отправку' },
  { value: 'OTHER', label: 'Другое' },
];

export type ClientReceiptResult = 'RECEIVED' | 'PROBLEM';
